/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 *
 * Where the focus goes when the control that holds it is about to disappear:
 * the first focusable element after `node` in document order, outside it. The
 * resume chip's dismiss (ResumeCompareChip.tsx) and the changes strip's
 * "Verbergen" (ChangesStrip.tsx) hand the focus on with it instead of letting
 * it fall back to the page.
 */

const FOCUSABLE_SELECTORS =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

/** The first control after `node` in document order, where focus goes once `node` is gone. */
export const nextFocusable = (node: HTMLElement): HTMLElement | null => {
  const candidates = Array.from(document.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTORS));
  return (
    candidates.find(
      (el) =>
        !node.contains(el) &&
        Boolean(node.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING)
    ) ?? null
  );
};
